const home = {
    "home.title": "Başlangıç noktasına hoş geldin!",
    "home.subtitle": "İhtiyacın olan tüm bilgileri {gettingStarted} kısmında bulabilirsin!"
};

export default home;